import React from "react";

const WebPages_Razor = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Razor</h1>
      <p>This is the WebPages Razor page content.</p>
    </div>
  );
};

export default WebPages_Razor;
